import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { PagedResponse, Prefix, PrefixImpact, PrefixUpdate } from '../types'

const BASE = '/management/prefixes'

export interface PrefixQuery {
  page: number
  size: number
}

/**
 * Ön ek tanımları listesi (056) — **sunucu-tarafı** sayfalama. `sort` parametresi **gönderilmez**:
 * düzen sunucuda sabittir (`ID` artan) ve uç gelen sıralamayı yok sayar.
 */
export async function getPrefixes({ page, size }: PrefixQuery): Promise<PagedResponse<Prefix>> {
  const { data } = await apiClient.get<PagedResponse<Prefix>>(BASE, { params: { page, size } })
  return data
}

/**
 * Ön ek değiştirilirse etkilenecek kayıt sayısı (FR-010a). Onay penceresinden **önce**, kaydete
 * basıldığında çağrılır (liste açılışında çağrılMAZ — gereksiz sayım sorgusu olmaz).
 */
export async function getPrefixImpact(id: number): Promise<PrefixImpact> {
  const { data } = await apiClient.get<PrefixImpact>(`${BASE}/${id}/impact`)
  return data
}

/** Ön ek tanımı (ad + ön ek) güncelleme (056). Durum değişmez; `modDate` optimistic lock. */
export async function updatePrefix(id: number, body: PrefixUpdate): Promise<Prefix> {
  const { data } = await apiClient.put<Prefix>(`${BASE}/${id}`, body)
  return data
}

/**
 * Ön ek listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportPrefixes(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'on-ekler.xlsx')
}
